export const SearchIcon: React.FC<{ size?: number; color?: string }> = ({
  size,
  color,
}) => (
  <svg
    width={size || 15}
    height={size || 15}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color || "currentColor"}
    strokeWidth={2}
    strokeLinecap="round"
  >
    <circle cx="11" cy="11" r="7" />
    <path d="M21 21l-4-4" />
  </svg>
);
